import { useTranslations } from '@vocab/react';
import { Dropdown, IconLocation } from 'braid-design-system';
import { useEffect, useState, type FormEvent } from 'react';

import translations from 'src/pages/ConnectedPartners/.vocab';
import { useConfig } from 'src/utils/hooks/useContext';
import { useQueryHistory } from 'src/utils/hooks/useQueryHistory';

interface Props {
  disabled: boolean;
}

export const RegionFilter = ({ disabled = false }: Props) => {
  const { locale } = useConfig();
  const { value, set } = useQueryHistory('region');
  const [location, setLocation] = useState<string>('All');

  const locationOnChange = (event: FormEvent<HTMLSelectElement>) => {
    const newLocationValue = (event.target as HTMLSelectElement).value;
    set(newLocationValue);
  };

  /**
   * Update the search value when the query changes.
   * This keeps the search value up to date when using browser back/forward buttons.
   */
  useEffect(() => {
    // First load use local as default value
    if (value === null) {
      set(locale);
    }
    setLocation(value ?? 'All');
  }, [value, set, locale]);

  const { t } = useTranslations(translations);

  return (
    <Dropdown
      id="region-filter"
      disabled={disabled}
      icon={<IconLocation />}
      label={t('region')}
      onChange={locationOnChange}
      value={location}
      placeholder={t('location')}
    >
      <option value="All">{t('all')}</option>
      <option value="AU">{t('Australia')}</option>
      <option value="NZ">{t('New Zealand')}</option>
      <option value="MY">{t('Malaysia')}</option>
      <option value="ID">{t('Indonesia')}</option>
      <option value="PH">{t('Philippines')}</option>
      <option value="SG">{t('Singapore')}</option>
      <option value="HK">{t('Hong Kong')}</option>
      <option value="TH">{t('Thailand')}</option>
    </Dropdown>
  );
};
